import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { InternalConsignorPurchaseBillingContainerModel } from "../../../../../../models/aggregates/erp/consignor";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class InternalConsignorPurchaseBillingService extends BaseApiTemplateService<InternalConsignorPurchaseBillingContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "internal-consignor-purchase-billings";
    this.httpClient = http;
  }

  getLinesByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria =
      this.apiUrl + "/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<
      PagingResponseModel<InternalConsignorPurchaseBillingContainerModel>
    >(UrlByCriteria, this.getHttpHeader(visa));
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string
  ): Observable<Blob> {
    let params;
    if (customParam) {
      params = new HttpParams()
        .set("printServiceClassName", printServiceClassName)
        .set("printableFormatHdrGuid", printableFormatGuid)
        .set("customParam", customParam);
    } else {
      params = new HttpParams()
        .set("printServiceClassName", printServiceClassName)
        .set("printableFormatHdrGuid", printableFormatGuid);
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + "/print-jasper-pdf/" + guid,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  public getAttachmentFile(
    extensionGuid: string,
    apiVisa: ApiVisa
  ): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + "/file/" + extensionGuid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }

  postCalculation(start_date: string, end_date: string, location_guid: string, inventory_item_guid: string, visa: ApiVisa): Observable<any> {

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/item/calc';
    }

    const body = {

      start_date: start_date,
      end_date: end_date,
      location_guid: location_guid,
      inventory_item_guid: inventory_item_guid

    };
    // let header = this.getHttpHeader(visa);
    return this.httpClient.post<ApiResponseModel<any>>(this.apiUrl, body, this.getHttpHeader(visa));

    // return this.httpClient.get<any>(this.apiUrl,headers:header)
  }
}
